import './style.scss';
import Application from './assets/js/application';

const app = new Application(document.body);

app.getLang();
